import { MirrorSelect } from '@crasman/multiselect';

/**
 * Initialize multiselect fields
 *
 * @class multiselect
 */
class multiselect {

  constructor() {
    this.multiselect = {};
  }

  init(){
    const dropdownElements = document.querySelectorAll('.js-select, .js-multiselect');

    const searchableOptions = {
      searchable: true,
      selectionClears: true,
    };

    const settings = {
      listElement: { size: 12 },
      buttonElement: { showPlaceholder: true },
      mirrorNative: true,
      setCssProperties: false,
    };

    // Add searchable textfield to only those that have correct data attribute
    dropdownElements.forEach(select => {
      if (select.dataset?.searchable) {
        settings.searchable = searchableOptions;
      }

      new MirrorSelect(select, settings);
    });

    const multiContainers = document.querySelectorAll('.multiselect-container');

    multiContainers.forEach(container => {

      const multisearch = container.querySelector('.multiselect-search');

      if (!multisearch) {
        return;
      }

      const searchInput = multisearch.querySelector('input');
      const selectElement = container.querySelector('select');
      const multiselectList = container.querySelector('.multiselect-list');
      const options = container.querySelectorAll('.multiselect-option');

      // Hide the text search input if there are less than 5 options
      if (options.length < 6) {
        const searchInput = container.querySelector(`input[type="search"]`);
        if (searchInput) {
          searchInput.remove();
        }
      }

      // Add event listener to clear search input on focus,
      // otherwise it will keep the last search value
      searchInput.addEventListener('focus', (event) => {
        event.target.value = '';
      });

      // Make filter has options in two different groups, "Suosituimmat" and "Aakkosittain.
      // Text search of mirror select is not able to filter options in correct way in both groups.
      // That's why we need to create a workaround and filter options manually in "Aakkosittain".
      searchInput.addEventListener('input', (event) => {
        if (selectElement.name === 'make') {
          const multiselectGroup = container.querySelectorAll('li.multiselect-group');
          const popularOptions = multiselectGroup[0]?.querySelectorAll('.multiselect-option');
          const allOptions = multiselectGroup[1]?.querySelectorAll('.multiselect-option');

          if (popularOptions && allOptions) {
            popularOptions.forEach(option => {
              const allOption = Array.from(allOptions).find(allOption => allOption.dataset.value === option.dataset.value);
              if (option.hidden) {
                // Add hidden attributes to corresponding "Aakkosittain" options
                allOption.setAttribute('hidden', '');
                allOption.setAttribute('aria-hidden', true);
              }
              else {
                // Remove hidden attributes from corresponding "Aakkosittain" options
                allOption.removeAttribute('hidden');
                allOption.removeAttribute('aria-hidden');
              }

            });
          }
        }
      });

      const placeholderArray = [];

      // Update placeholder on page load
      options.forEach(option => {
        if (option.classList.contains('selected') && option.dataset.value) {
          placeholderArray.push(option.innerHTML);
        }
        searchInput.placeholder = placeholderArray.join(', ');

        // Add checkbox look-alike to options if multiselect
        if (selectElement.hasAttribute('multiple')) {
          const checkboxContainer = document.createElement('span');
          checkboxContainer.classList.add('multiselect-option__checkbox-container');
          option.appendChild(checkboxContainer);

          const checkbox = document.createElement('span');
          checkbox.classList.add('multiselect-option__checkbox');
          checkboxContainer.appendChild(checkbox);
        }
      });

      // Add clear all buttons to multiselect list
      if (selectElement.hasAttribute('multiple')) {
        const unselectAllButton = document.createElement('li');
        unselectAllButton.classList.add('multiselect-list__unselect-all');
        unselectAllButton.innerHTML = '<button class="btn tertiary">Tyhjennä valinnat</button>';
        multiselectList.appendChild(unselectAllButton);

        unselectAllButton.addEventListener('click', () => {

          selectElement.querySelectorAll('option').forEach(opt => {
            opt.removeAttribute('selected');
          });

          searchInput.placeholder = '';
          selectElement.value = '';
          searchInput.value = '';
        });
      }



      // Update placeholder when user changes selection
      selectElement.addEventListener('change', (e) => {
        const options = [];
        for (const option of e.target.selectedOptions) {
          if (option.value) {
            options.push(option.label);
          }
        }
        searchInput.placeholder = options.join(', ');
      });
    });
  }
}

export default new multiselect();
